/**
 * @file   src\components\Payments\AddPaymentModalStripe.js
 * @brief  This file is responsible for add payment method
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useState } from "react";
import PaymentComponent from "./PaymentComponent";
import { Elements } from "@stripe/react-stripe-js";
import { getStripe } from "@/services/stripe";
import Modal from "react-bootstrap/Modal";
import useIsMobile from "@/hooks/useIsMobile";

const AddPaymentModalStripe = (props) => {

  const isMobile = useIsMobile();

  return (
    <Modal
      show
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-settings modal-payment plan-payment"
      fullscreen={isMobile}
    >
      <Modal.Body className="pt-32 pb-32" style={isMobile ? { justifyContent: 'center', display: 'flex', flexDirection: 'column' } : {}}>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={props.onHide}
        ></button>
        <Elements stripe={getStripe()}>
          <PaymentComponent {...props} />
        </Elements>
      </Modal.Body>
    </Modal>
  );
};
export default AddPaymentModalStripe;
